import MetricBase from "models/metrics/MetricBase";
import PerformanceGroup from "models/groups/PerformanceGroup";
import i18n from "i18next";
import PercentUnit from "models/metrics/unit/PercentUnit";

class MetricGeneratedGhaPPA extends MetricBase {
    constructor() {
        super({
            field: "metric_generated",
            defaultVisibility: true,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.google_hotel_ads_ppa.generated.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads_ppa.generated.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads_ppa.generated.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricGeneratedGhaPPA;
